import cuid from "cuid";
import { groupBy } from "lodash";
import { DEPARTMENTS, SKILL_TYPES } from "utils/constants";

const resolveDepartmentFormState = (savedValues) => {
  const all = DEPARTMENTS;
  const excluded = all.filter((code) => !savedValues.includes(code));
  const isExcludeMode =
    excluded.length > 0 && excluded.length < savedValues.length;

  return {
    departmentSelection: isExcludeMode ? excluded : savedValues,
    departmentExclude: isExcludeMode,
  };
};

export const getSkillGroupIndex = (skill) => skill?.groupIndex || 0;

/** Collapse API department skill rows into one form row per group with multiselect state. */
export const collapseSkillsForForm = (skills = []) => {
  const departmentSkills = skills.filter(
    ({ type }) => type === SKILL_TYPES.DEPARTMENT,
  );
  const otherSkills = skills
    .filter(({ type }) => type !== SKILL_TYPES.DEPARTMENT)
    .map((skill) => ({ ...skill, groupIndex: getSkillGroupIndex(skill) }));

  const departmentRows = Object.values(
    groupBy(departmentSkills, getSkillGroupIndex),
  ).map((groupSkills) => ({
    id: groupSkills[0].id,
    type: SKILL_TYPES.DEPARTMENT,
    value: null,
    groupIndex: getSkillGroupIndex(groupSkills[0]),
    ...resolveDepartmentFormState(groupSkills.map(({ value }) => value)),
  }));

  return [...otherSkills, ...departmentRows];
};

/** Expand department multiselect (+ exclude) into one skill row per included value, keeping its group. */
export const expandSkillsForApi = (skills = []) => {
  return skills.flatMap((skill) => {
    const groupIndex = getSkillGroupIndex(skill);
    if (skill.type !== SKILL_TYPES.DEPARTMENT) {
      const { departmentSelection, departmentExclude, ...apiSkill } = skill;
      return [{ ...apiSkill, groupIndex }];
    }

    const selected = skill.departmentSelection || [];
    const exclude = !!skill.departmentExclude;
    const includedValues = exclude
      ? DEPARTMENTS.filter((code) => !selected.includes(code))
      : selected;

    return includedValues.map((value, index) => ({
      id: index === 0 && skill.id ? skill.id : cuid(),
      type: SKILL_TYPES.DEPARTMENT,
      value,
      groupIndex,
    }));
  });
};
